export default {"src":"/_next/static/media/playoff-pair-addtime.e8744be1.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};